import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Contributors
 * id E05A9EE4-A599-4195-93F9-0E4024670E81
 * name dot-net
 * version: 2.7.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/dot-net.svg
 * tags
 * - Developer / Languages 
 * - Brand / Logo 
 */
export const DotNetIcon = createSvgIcon(<><path d="M2,15A1,1 0 0,1 3,16A1,1 0 0,1 2,17A1,1 0 0,1 1,16A1,1 0 0,1 2,15M21,17H19V9H17V7H23V9H21V17M16,7V9H14V11H16V13H14V15H16V17H12V7H16M11,7V17H9L6,11V17H4V7H6L9,13V7H11Z" /></>, 'DotNetIcon');
export default DotNetIcon